import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { Header } from "./components/header";
import { Stepper } from "./components/stepper/index";
import { CountdownTimer } from "./components/timer";
import { Title } from "./components/title";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { v4 as uuid } from "uuid";
import { Plan } from "./components/plan";
import { getUserSubscriptionThunk } from "src/redux/slices/userSlice";
import { DiscountProvider } from "@hooks/useDiscount";
import { getAgreementTextUpsale } from "src/routes/containers/paywalls/shared/components/plan/utils/getPlanDetails";
import { useUserUpsalePlans } from "./hooks/useUserUpsalePlans";
import { Loader } from "@common/loader";

export const Upsale = ({ variant }) => {
  const isWalky = variant === 'walky';
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [idempotencyKey] = useState(() => uuid());

  const { isLoading, plans, activePlan } = useUserUpsalePlans();

  useEffect(() => {
    dispatch(getUserSubscriptionThunk());
  }, [dispatch]);

  const handleSkip = () => {
    navigate("/activate");
  };

  return isLoading ? (
    <Loader />
  ) : (
    <DiscountProvider>
      <Header onSkip={handleSkip} />
      <div className={styles.layout}>
        <Stepper isWalky={isWalky}/>
        <Title />
        <CountdownTimer />
        <Plan
          idempotencyKey={idempotencyKey}
          onSkip={handleSkip}
          isWalky={isWalky}
          plans={plans}
        />
        <p className={styles.note}>{getAgreementTextUpsale(activePlan)}</p>
      </div>
    </DiscountProvider>
  );
};
